module.exports = __webpack_public_path__ + "img/ic_fluent_delete_20_regular.44c893a3.svg";